<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>设备列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>设备列表</span>
        </div>
        <div style="display: flex">
          <el-button @click="dialogFormVisible = true" icon="el-icon-plus" type="primary">添加设备</el-button>
          <el-button @click="dialogFormSwitch = true" icon="el-icon-bottom" type="warning">批量导入</el-button>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-select v-model="search.type" placeholder="全部类型">
              <el-option label="请选择" :value="-1"></el-option>
              <el-option label="已过期" :value="0"></el-option>
              <el-option label="未过期" :value="1"></el-option>
              <el-option label="未绑定" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入MID" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-tabs type="border-card" @tab-click="changeData">
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-microphone"></i> 入网设备
          </span>
          <div class="xcx-content">
            <!--列表-->
            <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
              <el-table-column prop="id" label="Id" width="80"></el-table-column>
              <el-table-column prop="dev_id" label="设备ID" width="130"></el-table-column>
              <el-table-column prop="devid" label="模块ID" width="120"></el-table-column>
              <el-table-column prop="central_v" label="中控版本" width="100"></el-table-column>
              <el-table-column prop="touch_v" label="触控版本" width="100"></el-table-column>
              <el-table-column prop="aside_v" label="按钮版本" width="100"></el-table-column>
              <el-table-column prop="join_time" label="入库日期" width="180"></el-table-column>
              <el-table-column prop="company" label="厂家信息"></el-table-column>
              <el-table-column prop="is_load" label="是否装车" width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.is_load">{{ scope.row.is_load }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="load_time" label="装车时间" width="180"></el-table-column>
              <el-table-column label="到期时间" width="120">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.status == 1">{{ scope.row.etime }}</el-tag>
                  <el-tag type="info" v-else-if="scope.row.status == 2">未绑定</el-tag>
                  <el-tag type="danger" v-else>{{ scope.row.etime }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="iccid" label="设备状态" width="120">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.online">在线</el-tag>
                  <el-tag type="info" v-else>离线</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'edit')">编辑</el-dropdown-item>
                      <el-dropdown-item :command="beforeHandleCommand(scope.row, 'times')">延长时间</el-dropdown-item>
                      <el-dropdown-item :command="beforeHandleCommand(scope.row, 'qrcode')">设备二维码</el-dropdown-item>
                      <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'del')">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <!--分页-->
            <div class="paging">
              <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="prev, pager, next" :total="count"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-turn-off-microphone"></i> 未网设备
          </span>
          <div class="xcx-content">
            <!--列表-->
            <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
              <el-table-column prop="id" label="Id" width="80"></el-table-column>
              <el-table-column prop="dev_id" label="设备ID" width="130"></el-table-column>
              <el-table-column prop="devid" label="模块ID" width="120"></el-table-column>
              <el-table-column prop="central_v" label="中控版本" width="100"></el-table-column>
              <el-table-column prop="touch_v" label="触控版本" width="100"></el-table-column>
              <el-table-column prop="aside_v" label="按钮版本" width="100"></el-table-column>
              <el-table-column prop="join_time" label="入库日期" width="180"></el-table-column>
              <el-table-column prop="company" label="厂家信息"></el-table-column>
              <el-table-column prop="is_load" label="是否装车" width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.is_load">{{ scope.row.is_load }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="load_time" label="装车时间" width="180"></el-table-column>
              <el-table-column label="到期时间" width="120">--</el-table-column>
              <el-table-column label="设备状态" width="120">未知</el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'edit')">编辑</el-dropdown-item>
                      <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'del')">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <!--分页-->
            <div class="paging">
              <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total,prev, pager, next" :total="count"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 导入开关 -->
    <el-dialog title="批量导入设备" width="33%" :visible.sync="dialogFormSwitch">
      <el-form :model="filesForm" :rules="files_rules" ref="filesForm">
        <el-form-item label="上传文件：" :label-width="formLabelWidth" prop="filesUrl">
          <el-upload class="upload-demo" name="image" action="https://api.iztrv.com/uploadfile" :on-success="handleAvatarSuccess" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormSwitch = false">取 消</el-button>
        <el-button type="primary" @click="submitImportForm('filesForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加设备" width="40%" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" size="mini" :rules="rules" ref="ruleForm">
        <el-form-item label="设备ID :" :label-width="formLabelWidth" prop="dev_id">
          <el-input v-model="ruleForm.dev_id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="模块ID：" :label-width="formLabelWidth" prop="devid">
          <el-input v-model="ruleForm.devid" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="中控版本：" :label-width="formLabelWidth" prop="central_v">
          <el-input v-model="ruleForm.central_v" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="触控版本：" :label-width="formLabelWidth" prop="touch_v">
          <el-input v-model="ruleForm.touch_v" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="按钮版本：" :label-width="formLabelWidth" prop="aside_v">
          <el-input v-model="ruleForm.aside_v" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="入库日期：" :label-width="formLabelWidth" prop="desc">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.join_time" type="datetime" placeholder="选择装车时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="厂家名称：" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.company" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="厂家信息：" :label-width="formLabelWidth" prop="company">
          <el-select v-model="ruleForm.company_id" placeholder="请选择厂家">
            <el-option label="请选择" :value="0"></el-option>
            <el-option v-for="item in company" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌信息：" :label-width="formLabelWidth" prop="company">
          <el-select v-model="ruleForm.brand_id" placeholder="请选择品牌">
            <el-option label="请选择" :value="0"></el-option>
            <el-option v-for="item in brand" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型：" :label-width="formLabelWidth" prop="model_v">
          <el-input v-model="ruleForm.model_v" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="型号：" :label-width="formLabelWidth" prop="type_v">
          <el-input v-model="ruleForm.type_v" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否装车：" :label-width="formLabelWidth" prop="is_load">
          <el-radio-group v-model="ruleForm.is_load">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否入网：" :label-width="formLabelWidth" prop="network">
          <el-radio-group v-model="ruleForm.network">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="装车时间：" :label-width="formLabelWidth" prop="load_time">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.load_time" type="datetime" placeholder="选择装车时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="设备到期时间：" :label-width="formLabelWidth" prop="etime">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.etime" type="datetime" placeholder="选择设备到期时间"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="qrcodeVisible" width="320px" :title="devid + '设备二维码'" @close="closeDialog" v-loading="loading">
      <el-image style="width: 280px; height: 280px" :src="url" :preview-src-list="srcList"></el-image>
    </el-dialog>

    <el-dialog title="延长时间" width="40%" :close-on-click-modal="false" :visible.sync="dialogTimesVisible">
      <el-form :model="timeForm" ref="timeForm">
        <el-form-item label="到期时间：" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd" v-model="timeForm.etime" type="date" placeholder="选择到期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTimesVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTimesForm('timeForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogTimesVisible: false,
      timeForm: {
        etime: "",
      },
      qrcodeVisible: false,
      devid: 0,
      url: "",
      network: 1,
      srcList: [],
      company: [],
      brand: [],
      loading: true,
      tableData: [],
      id: 0,
      page: 0,
      count: 0,
      limit: 10,
      search: {
        type: -1,
        keys: "",
      },
      dialogFormVisible: false,
      formLabelWidth: "120px",
      ruleForm: {
        dev_id: "",
        devid: "",
        central_v: "",
        touch_v: "",
        aside_v: "",
        model_v: "",
        type_v: "",
        join_time: "",
        company_id: 0,
        company: "",
        brand_id: 0,
        is_load: 1,
        load_time: "",
        etime: "",
        network: 1,
      },
      rules: {
        dev_id: [{ required: true, message: "请填写设备ID", trigger: "blur" }],
        devid: [{ required: true, message: "请填写模块ID", trigger: "blur" }],
        central_v: [
          { required: true, message: "请填写中控版本", trigger: "blur" },
        ],
        urtouch_vls: [
          { required: true, message: "请填写触屏版本", trigger: "blur" },
        ],
        aside_v: [
          { required: true, message: "请填写开关版本", trigger: "blur" },
        ],
      },
      dialogFormSwitch: false,
      fileList: [],
      filesForm: {
        filesUrl: "",
      },
      files_rules: {
        filesUrl: [
          { required: true, message: "请上传文件", trigger: "change" },
        ],
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getComBrand() {
      var that = this;
      that.axios.post("/dev/get_dev_com_brand").then((res) => {
        if (res) {
          that.company = res.data.company;
          that.brand = res.data.brand;
        }
      });
    },

    changeData(e) {
      if (e.index == 1) {
        this.network = 0;
      } else {
        this.network = 1;
      }
      this.getList();
    },

    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "edit":
          var that = this;
          that.id = command.row;
          that.getComBrand();
          that.axios.post("/dev/edit", { id: command.row }).then((res) => {
            if (res) {
              that.ruleForm = res.data;
              that.dialogFormVisible = true;
            }
          });
          break;
        case "qrcode":
          const qrcode_loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)",
          });
          var that = this;
          that.devid = command.row.devid;
          that.axios
            .post("/get_dev_Qrcode", {
              devid: command.row.devid,
              dev_id: command.row.dev_id,
            })
            .then((res) => {
              if (res) {
                that.url = res.data;
                that.srcList[0] = res.data;
                that.qrcodeVisible = true;
                console.log(res);
                qrcode_loading.close();
              }
            });
          break;
        case "times":
          this.timeForm.etime = command.row.etime;
          this.id = command.row.id;
          this.dialogTimesVisible = true;
          break;
        case "del":
          this.del_item(command.row);
          break;
      }
    },

    closeDialog() {
      //this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false;
      this.ruleForm.dev_id = "";
      this.ruleForm.devid = "";
      this.ruleForm.central_v = "";
      this.ruleForm.touch_v = "";
      this.ruleForm.aside_v = "";
      this.ruleForm.join_time = "";
      this.ruleForm.company = "";
      this.ruleForm.is_load = "";
      this.ruleForm.load_time = "";
      this.ruleForm.etime = "";
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/dev/store";
        if (that.id) {
          formData.id = that.id;
          url = "/dev/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },

    submitTimesForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.timeForm;
        formData.id = that.id;
        var url = "/dev/update_etime";
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogTimesVisible = false;
          that.getList();
        });
      });
    },

    handleAvatarSuccess(res, file) {
      this.filesForm.filesUrl = res.msg;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submitImportForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.filesForm;
        var url = "/dev/import";
        that.axios.post(url, formData).then(() => {
          that.$message.success("批量导入成功");
          that.dialogFormSwitch = false;
          that.filesForm.filesUrl = "";
          that.getList();
        });
      });
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },

    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/dev/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.search.type = -1;
      this.page = 0;
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.type = that.search.type;
      formData.network = that.network;
      that.axios.post("/dev/dev_info", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
.xcx-content {
  padding: 0;
}

.search-box {
  padding: 0 15px;
}
</style>